import PropTypes from "prop-types";
import React, { useState, useEffect, Fragment } from "react";
import { connect } from "react-redux";
import axios from "axios";
import config from "../../utils/config";
import { useHistory } from "react-router-dom";
import { removeUnicode } from "../../utils/utilityFunctions";
import { Link } from "react-router-dom";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import Skeleton from "@mui/material/Skeleton";

import { makeStyles } from "tss-react/mui";
import { Divider, TextField } from "@mui/material";
import Button from "@mui/material/Button";

const useStyles = makeStyles()((theme) => ({
  aside: {
    display: "flex",
    flexDirection: "column",
    width: 300,
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
    padding: 30,
    borderLeft: "1px solid #ededed",
  },
  searchDiv: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
  textField: {
    width: "100%",
    marginBottom: 10,
  },
  searchButton: {
    width: "100%",
  },
  sidebarVideo: {
    paddingTop: 30,
  },
  divider: {
    margin: `${theme.spacing(1)} 0px`,
  },
  startATrialDiv: {
    // make sticky
    position: "sticky",
    top: 100,
  },
  startTrialButton: {
    height: 50,
  },
}));

export const Sidebar = (props) => {
  const { classes } = useStyles();
  const history = useHistory();

  let { searchPosts } = props;

  const [categories, setCategories] = useState([]);
  const [recentPosts, setRecentPosts] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [showVideo, setShowVideo] = useState(false);

  useEffect(() => {
    // Get wordpress categories
    axios
      .get("https://blog.contentgenerator.io/wp-json/wp/v2/categories")
      .then((res) => {
        setCategories(res.data);
      })
      .catch((err) => {
        console.error("Failed to get blog categories", err);
      });

    // Get recent posts (only published)
    axios
      .get(
        "https://blog.contentgenerator.io/wp-json/wp/v2/posts?per_page=5&status=publish"
      )
      .then((res) => {
        setRecentPosts(res.data);
      })
      .catch((err) => {
        console.error("Failed to get recent blog posts", err);
      });

    return () => {
      setCategories([]);
      setRecentPosts([]);
    };
  }, []);

  function handleOnKeyDown(e) {
    // If the user presses the enter key
    // then we want to redirect to the search page
    if (e.keyCode === 13) {
      handleSearch();
    }
  }

  function handleSearch() {
    history.push(`/blog/?search=${searchText}`);
    if (searchPosts) {
      searchPosts(searchText);
    }
  }

  return (
    <aside className={classes.aside}>
      <form
        className={classes.searchDiv}
        role="search"
        onSubmit={(e) => {
          e.preventDefault();
          handleSearch();
        }}
      >
        <TextField
          id="sidebar-search-input"
          name="sidebar-search"
          label="Search"
          variant="outlined"
          onKeyDown={handleOnKeyDown}
          onChange={(e) => setSearchText(e.target.value)}
          className={classes.textField}
          size="small"
          inputProps={{ "aria-label": "Search" }}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={handleSearch}
          className={classes.searchButton}
          type="submit"
        >
          Search
        </Button>
      </form>

      <h3 style={{ marginBottom: 5 }}>Categories</h3>
      {categories.length === 0
        ? Array.from({ length: 10 }).map((_, idx) => (
            <Skeleton
              key={idx}
              variant="text"
              width={200}
              height={28}
              style={{ marginBottom: 4 }}
            />
          ))
        : categories
            .filter((category) => category.id !== 1) // Hide "Uncategorized"
            .map((category) => (
              <a
                href={config.baseURL + "/blog/?category=" + category.id}
                key={category.id}
              >
                {removeUnicode(category.name)} ({category.count})
              </a>
            ))}
      <div className={classes.sidebarVideo}>
        {!showVideo ? (
          <div
            style={{
              position: "relative",
              width: "300px",
              height: "168px",
              cursor: "pointer",
              background: "#000",
            }}
            onClick={() => setShowVideo(true)}
          >
            <img
              src={require("./tutorial_thumbnail.webp")}
              alt="YouTube video thumbnail"
              width="300"
              height="168"
              style={{ display: "block" }}
            />
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                pointerEvents: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <span
                style={{
                  background: "#ff0032",
                  borderRadius: "50%",
                  width: 60,
                  height: 60,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                }}
              >
                <PlayArrowIcon style={{ color: "#FFF", fontSize: 36 }} />
              </span>
            </div>
          </div>
        ) : (
          <iframe
            width="300"
            height="168"
            src="https://youtu.be/XzI0gGKrwUI"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        )}
      </div>
      <h3 style={{ marginBottom: 16 }}>Recent posts</h3>
      {recentPosts.length === 0
        ? Array.from({ length: 5 }).map((_, idx) => (
            <Skeleton
              key={idx}
              variant="text"
              width={300}
              height={90}
              style={{ marginBottom: 8 }}
            />
          ))
        : recentPosts.map((post, index) => {
            return (
              <div key={`post${index}`}>
                <a href={config.baseURL + "/blog/" + post.slug} key={post.id}>
                  {removeUnicode(post.title.rendered)}
                </a>
                <Divider className={classes.divider} variant="fullWidth" />
              </div>
            );
          })}
      <div className={classes.startATrialDiv}>
        <Button
          variant="contained"
          color="primary"
          component={Link}
          to={"/generate"}
          fullWidth
          size="large"
          className={classes.startTrialButton}
        >
          Try it for free
        </Button>
      </div>
    </aside>
  );
};

Sidebar.propTypes = {};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
